import { Section } from '@/components/layout';
import { ResponsiveImage } from '@/components/media';
import { BunnyVideo } from '@/components/media/BunnyVideo';
import { Reveal } from '@/components/motion';
import { Eyebrow } from '@/components/typography';
import { DividerCorazon } from '../icons/BogotaIcons';
import styles from './InvitadosBogota.module.css';

/** Vídeo AΩGR × AKASHA (38 s, vertical), subido a la librería Bunny del cliente el 17-sep-2026. */
const VIDEO_AKASHA = 'c40aa6ce-b9cb-410d-b595-95df12277a00';

/**
 * INVITADA ESPECIAL Y COLABORADOR — encargo del cliente por WhatsApp (17-sep-2026):
 * «Invitada especial, Carolina Salazar (foto de ella)» y «Colaborador (foto logo)»,
 * con la captura señalando el hueco entre la reserva y la fila de beneficios.
 *
 * CON EL IDIOMA DE BOGOTÁ, NO CON TARJETAS. La primera versión eran dos cajas con
 * filete y el cliente la pidió «adaptada a su diseño»: esta página no encaja
 * bloques, los separa con aire, antetítulo dorado, divisor de corazón y el filete
 * vertical de la fila de beneficios. Eso es lo que lleva ahora.
 *
 * El texto es SOLO el que mandó: los dos rótulos y el nombre. Nada de biografía ni
 * de descripción del colaborador que el cliente no haya escrito.
 *
 * El vídeo va con el colaborador porque ES del colaborador: abre con los logos
 * AΩGR y AKASHA y sigue con el público en sala. Vertical, marco 9:16.
 */
export function InvitadosBogota() {
  return (
    <Section background="surface" spacing="tight" width="default" className={styles.section}>
      <div className={styles.grid}>
        <Reveal className={styles.celda}>
          <article className={styles.columna} aria-labelledby="bogota-invitada">
            <Eyebrow ink="gold" align="center">
              <span id="bogota-invitada">Invitada especial</span>
            </Eyebrow>
            <DividerCorazon className={styles.divider} />
            <ResponsiveImage
              asset="bogota/carolina-salazar"
              sizes="(min-width: 48rem) 18rem, 76vw"
              className={styles.foto}
            />
            <h2 className={styles.nombre}>Carolina Salazar</h2>
          </article>
        </Reveal>

        <Reveal delay={0.08} className={styles.celda}>
          <article className={styles.columna} aria-labelledby="bogota-colaborador">
            <Eyebrow ink="gold" align="center">
              <span id="bogota-colaborador">Colaborador</span>
            </Eyebrow>
            <DividerCorazon className={styles.divider} />
            <ResponsiveImage asset="bogota/akasha-logo" sizes="8.5rem" className={styles.logo} />
            <div className={styles.marcoVideo}>
              <BunnyVideo
                videoId={VIDEO_AKASHA}
                description="Vídeo de AΩGR y AKASHA Despertar Espiritual con el público en sala"
                className={styles.video}
              />
            </div>
          </article>
        </Reveal>
      </div>
    </Section>
  );
}
